export const MEMBERSHIP_POLICY_SLUG_PREFIX = 'membership-policy';
export const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])$/g;
